import { Component, Input } from '@angular/core';

//
// Spinner theme
//
declare type Theme = 'dark' | 'light';

//
// Spinner size
//
declare type Size = 'small' | 'medium' | 'large' | 'x-large';
@Component({
    selector: 'dd-spinner',
    templateUrl: './dd-spinner.html',
    styleUrls: ['./dd-spinner.scss'],
    standalone: false
})
export class ddSpinner {
  @Input() public renderText = true;
  @Input() public theme: Theme = 'dark';
  @Input() public size: Size = 'large';
  public style: object = {};
  
}
